import React, { useState } from 'react'
import '../CSS/Calendar.css'
import Button from "@material-tailwind/react/Button";
import { Link } from 'react-router-dom'
import { useStateValue } from '../StateProvider';
import ReviewBooking from './ReviewBooking';
import NavOnlyIcons from './NavOnlyIcons';

const Calendar = () => {

    const [dateValue, setDateValue] = useState();
    const [getTime, getSetTime] = useState();
    const [{time}, dispatch] = useStateValue();

    const [setDate1,setDate1Active] = useState();
    const [setDate2,setDate2Active] = useState();
    const [setDate3,setDate3Active] = useState();
    const [setDate4,setDate4Active] = useState();
    const [setDate5,setDate5Active] = useState();
    const [setDate6,setDate6Active] = useState();
    const [setDate7,setDate7Active] = useState();
    const [visibleReview, setVisibleReview] = useState();
    // eslint-disable-next-line
    const [visibleCal,setVisibleCal] = useState(true);

    const handleClick = (e) => {
        dispatch({
            type : 'SET_DATE',
            date : dateValue
        })
        dispatch({
            type : 'SET_TIME',
            time : getTime 
        })
        setVisibleCal(false);
        setVisibleReview(true);
    }

    const handleDate1Click = () => {
        setDate1Active(true)
        setDate2Active(false)
        setDate3Active(false)
        setDate4Active(false)
        setDate5Active(false)
        setDate6Active(false)
        setDate7Active(false)
    }
    const handleDate2Click = () => {
        setDate2Active(true)
        setDate1Active(false)
        setDate3Active(false)
        setDate4Active(false)
        setDate5Active(false)
        setDate6Active(false)
        setDate7Active(false)
    }
    const handleDate3Click = () => {
        setDate3Active(true)
        setDate2Active(false)
        setDate1Active(false)
        setDate4Active(false)
        setDate5Active(false)
        setDate6Active(false)
        setDate7Active(false)
    }
    const handleDate4Click = () => {
        setDate4Active(true)
        setDate2Active(false)
        setDate3Active(false)
        setDate1Active(false)
        setDate5Active(false)
        setDate6Active(false)
        setDate7Active(false)
    }
    const handleDate5Click = () => {
        setDate5Active(true)
        setDate2Active(false)
        setDate3Active(false)
        setDate4Active(false)
        setDate1Active(false)
        setDate6Active(false)
        setDate7Active(false)
    }
    const handleDate6Click = () => {
        setDate6Active(true)
        setDate2Active(false)
        setDate3Active(false)
        setDate4Active(false)
        setDate5Active(false)
        setDate1Active(false)
        setDate7Active(false)
    }
    const handleDate7Click = () => {
        setDate7Active(true)
        setDate2Active(false)
        setDate3Active(false)
        setDate4Active(false)
        setDate5Active(false)
        setDate6Active(false)
        setDate1Active(false)
    }


    return (
        <>
        <div className="calendar">

            <div className="navDiv">
                <NavOnlyIcons />
            </div>

            <div className="calendarDiv">
                <div className="stepsDone">
                        <Link to='/AppointmentPage'>
                            <div className="stepOne" >       
                                <Button >1 Select Mode</Button>
                            </div>
                        </Link>
                        
                        <div className="stepTwo" >
                            <Button id='selectMode1'>2 Date & Time</Button>
                        </div>
                        
                    
                        <div className="stepThree">
                            <Button>3 Review data</Button>
                        </div>
                    
                </div>
                <div className="datesDiv">
                    <div className="datesDivOptions" onClick={handleDate1Click}>
                        <small>Tue</small>
                        <input type="button" value="Sep 10" 
                            onClick={(e) =>setDateValue(e.target.value)}
                            id={setDate1 ? 'activeDate' : ''}
                        />
                    </div>
                    <div className="datesDivOptions" onClick={handleDate2Click}>
                        <small>Wed</small>
                        <input type="button" value="Sep 11" 
                            onClick={(e) =>setDateValue(e.target.value)}
                            id={setDate2 ? 'activeDate' : ''}
                        />
                    </div>
                    <div className="datesDivOptions" onClick={handleDate3Click}>
                        <small>Thu</small>
                        <input type="button" value="Sep 12" 
                            onClick={(e) => setDateValue(e.target.value) }
                            id={setDate3 ? 'activeDate' : ''}
                        />
                    </div>
                    <div className="datesDivOptions" onClick={handleDate4Click}>
                        <small>Fri</small>
                        <input type="button" value="Sep 13" 
                            onClick={(e) =>setDateValue(e.target.value)}
                            id={setDate4 ? 'activeDate' : ''}
                        />
                    </div>
                    <div className="datesDivOptions" onClick={handleDate5Click}>
                        <small>Sat</small>
                        <input type="button" value="Sep 14" 
                            onClick={(e) =>setDateValue(e.target.value)}
                            id={setDate5 ? 'activeDate' : ''}
                        />
                    </div>
                    <div className="datesDivOptions" onClick={handleDate6Click}>
                        <small>Sun</small>
                        <input type="button" value="Sep 15" 
                            onClick={(e) =>setDateValue(e.target.value)}
                            id={setDate6 ? 'activeDate' : ''}
                        />
                    </div>
                    <div className="datesDivOptions" onClick={handleDate7Click}>
                        <small>Mon</small>
                        <input type="button" value="Sep 16" 
                            onClick={(e) =>setDateValue(e.target.value)}
                            id={setDate7 ? 'activeDate' : ''}
                        />
                    </div>
                </div>

                

                <div className="timeSlotsDiv">

                    <div className="timeSlotsDivOne">
                            <input type="button" value="09 : 00 AM" onClick={(e) =>getSetTime(e.target.value)}/>
                            <input type="button" value="10 : 00 AM" onClick={(e) =>getSetTime(e.target.value)} />
                            <input type="button" value="11 : 00 AM" onClick={(e) =>getSetTime(e.target.value)} />
                            <input type="button" value="12 : 00 PM" onClick={(e) =>getSetTime(e.target.value)} />
                    </div>

                    <div className="timeSlotsDivOne">
                            <input type="button" value="01 : 00 PM" onClick={(e) =>getSetTime(e.target.value)}/>
                            <input type="button" value="02 : 00 PM" onClick={(e) =>getSetTime(e.target.value)}/>
                            <input type="button" value="03 : 00 PM" onClick={(e) =>getSetTime(e.target.value)}/>
                            <input type="button" value="04 : 00 PM" onClick={(e) =>getSetTime(e.target.value)}/>
                    </div>
                </div>
                {
                    dateValue || time ? (
                        <div className="SelecteDateTimeDiv">
                            <h1>{dateValue} and {getTime}</h1>
                            <div className="continueButton">
                                <Button color="lightBlue" buttonType="filled" size="regular" iconOnly={false} ripple="light" onClick={handleClick}>
                                    Continue
                                </Button> 
                            </div>
                        </div>
                    ) : (
                        <div  className="SelecteDateTimeDiv"><h1>Please Select Date and Time</h1></div>
                    )
                }
                
            </div> 
        </div>
        <div className={visibleReview ? "reviewDivModeHide" : "reviewDivMode" }>
            <ReviewBooking />
        </div>
    </>
    )
}

export default Calendar
